// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2m4Z_","content":"style_content__3Bsrj","description":"style_description__76Jo0","back":"style_back__3L6j3","logo":"style_logo__3kZ7x"};